<div class="confirmar">
  <h1 class="confirmar__title">Aviso de cierre de sesión</h1>
  <p class="confirmar__description">Tu sesión está a punto de expirar, ¿necesitas más tiempo?</p>
  <div class="confirmar__buttons">
    <ion-button
      expand="full"
      class="eliminar"
      shape="round"
      (click)="ok()"> 
      <span>MANTENER SESIÓN ACTIVA</span>
      <!-- <ion-spinner class="ion-float-left" style=" --color: primary; margin-left: 10px;" *ngIf="loading"></ion-spinner> -->
    </ion-button>
    <ion-button
      expand="full"
      class="cancelar"
      shape="round"
      (click)="cancel()"> 
      <span>CERRAR SESIÓN</span>
    </ion-button>
  </div>
</div>
